import React from 'react';
import TableComponent from '../../components/TableComponent';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';
import { filterTypeformSurveys } from '../../utils/miscFunctions';
import { compareDesc } from 'date-fns';
import { SurveyContext }  from '../../SurveyContext';
import { format } from 'date-fns';

import { shortDateAndFullTimeFormat } from '../../utils/datesFormat';

class HomePage extends React.Component {
    constructor(props) {
        super();
        this.state = {
            page: 0,
            rowsPerPage: 10,
            searchTerm: '',
        }
    }

    goToCreate = () => {
        this.props.history.push('/surveys/create');
    }

    updateState = (value, state) => {
        this.setState({
            [state]: value
        }, () => {
            if (state === 'searchTerm') {
                this.updateState(0, "page");
            }
        })
    }

    onRowClick = (data) => {
        const url = `/surveys/${data.id}`;
        this.props.history.push(url);
    }

    render() {
        const { searchTerm, rowsPerPage, page } = this.state;
        const { loading, loadingRest, activeSurveys, totalActiveSurveys, lastLoaded, getActiveSurveys } = this.context;
        let filteredSurveys = activeSurveys.filter(filterTypeformSurveys(searchTerm));
        filteredSurveys = filteredSurveys.sort((a, b) => compareDesc(new Date(a.last_updated_at), new Date(b.last_updated_at)));
        return (
            <div style={{ textAlign: 'center', position: 'relative', width: '100%' }}>
                <h2>Active Surveys</h2>
                <Button onClick={this.goToCreate} style={{ position: 'absolute', right: 30, top: 0, width: 150 }} variant="outlined" color="primary"> New Survey </Button>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <TextField
                    id="search-input" variant="outlined"
                    value={searchTerm}
                    onChange={(e) => this.updateState(e.target.value, "searchTerm")}
                    InputProps={{ startAdornment: (<InputAdornment position="start"> <SearchIcon /> </InputAdornment>) }}
                    style={styles['search']}
                    autoComplete="off"
                    label="Search by ID or name"
                />
                <div style={{display: 'flex', flexDirection: 'column', paddingTop: 10 }}>
                    <Button variant="outlined" onClick={getActiveSurveys}>
                        Refresh Surveys
                    </Button>
                    <label style={{fontSize: 12, margin: 3}}> {`Last loaded at ${format(lastLoaded, shortDateAndFullTimeFormat)}`} </label>
                </div>
                </div>
                {loadingRest &&
                    <p style={{ position: 'absolute', left: 10, top: 0, fontSize: 12 }}>{`${activeSurveys.length} surveys loaded / ${totalActiveSurveys} total`}</p>
                }
                {(!loading && totalActiveSurveys) ?
                    <TableComponent
                        data={filteredSurveys}
                        headers={["ID", "Name", "Customer", "Campaign Type", "Last Updated"]}
                        fields={["id", "title", "customer", "campaignType", "last_updated_at"]}
                        updateState={this.updateState}
                        onRowClick={this.onRowClick}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        count={filteredSurveys.length}
                        type="surveys"
                    />
                    :
                    <p> {loading ? 'Loading data...' : 'No results found.'}</p>
                }
            </div>
        )
    }
}

const styles = {
    'search': {
        width: '50%',
        margin: 10,
        float: 'left'
    }
}

HomePage.contextType = SurveyContext;

export default HomePage;